<template>
  <div class="app" v-if="appshow">
    <Header :resData="pagedata.nav"></Header>
    <div class="main">
      <component :resData="pagedata[mainshow]" :is="mainshow"></component>
    </div>
    <Footer :resData="pagedata.footer"></Footer>
  </div>
</template>

<script>
  import Header from '../../components/header.vue';
  import Footer from '../../components/footer.vue';
  import index from '../../components/index.vue';
  import news from '../../components/news.vue';
  import product from '../../components/product.vue';
  import company from '../../components/company.vue';
  import detail from '../../components/details.vue';
  import ProductDetail from '../../components/product-details.vue';
  export default{
    data(){
      return{
        languages:'english',
        allData:'',
        pagedata:'',
        mainshow:'index',
        appshow:false
      }
    },
    components:{
      Header,Footer,index,news,product,company,detail,ProductDetail
    },
    watch:{
      $route(to,from){
        this.mainshow=this.$route.name;
      }
    },
    methods:{
      mainfun(type){
        this.mainshow=type
      },
      languagefun(val){
        this.$cookieStore.addCookie( 'languages',val,1);
        this.pagedata=this.allData[val];
      },
      getlan(){
        if(this.$cookieStore.getCookie( 'languages') && this.$cookieStore.getCookie( 'languages')!=undefined){
          this.languages=this.$cookieStore.getCookie( 'languages');
        }
        this.axios.get('/static/language.json').then(res => {
            this.allData=res.data.data;
            this.pagedata=res.data.data[this.languages];
        })
      },
      async getdata(){
        await this.$store.dispatch('getData');
        if(this.$cookieStore.getCookie( 'languages') && this.$cookieStore.getCookie( 'languages')!=undefined){
          this.languages=this.$cookieStore.getCookie( 'languages');
          this.$store.commit('changeLanguage',this.languages);
        }
        this.appshow=true;
      }
    },
    mounted(){
      this.mainshow=this.$route.name;
      this.getdata();
    }
  }
</script>

<style scoped>
  .main{
    background-color: #F7F7F7;
    /* min-height: calc(100vh - 88px); */
    min-height: calc(100vh - 129px);
    box-sizing: border-box;
    padding-bottom: 3%;
  }
  @media screen and (max-width: 1000px){
    .app{
        max-width: 750px;
        margin: auto;
        position: relative;
    }
    .main{
      /* min-height: calc(100vh - 120px); */
      min-height: calc(100vh - 129px);
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue